import { useQuery } from 'react-query';
import { CustomerCalendarApi } from '../../CustomerCalendarApi';
import { CalendarBroker } from '../../types';

export const CalendarBrokersQueryKey = 'customer-calendar-brokers';

export function useCalendarBrokersQuery(enabled: boolean) {
    return useQuery<CalendarBroker[]>(
        [CalendarBrokersQueryKey],
        () => CustomerCalendarApi.getBrokers(),
        {
            enabled,
            staleTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false
        }
    );
}
